export default "__VITE_ASSET__cQsyUbEB__"